module.exports = __webpack_public_path__ + "static/media/scanQR.142b7fd1.png";